import { render, staticRenderFns } from "./skuCoupon.vue?vue&type=template&id=1fbe8bc6&scoped=true&"
import script from "./skuCoupon.vue?vue&type=script&lang=js&"
export * from "./skuCoupon.vue?vue&type=script&lang=js&"
import style0 from "./skuCoupon.vue?vue&type=style&index=0&id=1fbe8bc6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe8bc6",
  null
  
)

export default component.exports